import * as React from 'react';
import Prompt from './Prompt';
import Split from './Split';
import Layer from '../data/Layer';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { Overlay } from '../components/Overlay';

interface Props {
  layer: Layer;
  skipQuestion: boolean;
}

interface State {
  skipQuestion: boolean;
}

export default class extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      skipQuestion: props.skipQuestion
    };
  }
  skipQuestion = () => {
    this.setState({ skipQuestion: true });
  };
  didCancel = () => {
    storeDispatch(Actions.closeModal());
  };
  render() {
    return (
      <Overlay opaque={this.state.skipQuestion}>
        {!this.state.skipQuestion ? (
          <Prompt onOk={this.skipQuestion} onCancel={this.didCancel} />
        ) : (
          <Split layer={this.props.layer} onCancel={this.didCancel} />
        )}
      </Overlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/split-layer/index.tsx